package ru.it_mozaika.sender.js.application.theme

import js.core.jso
import mui.material.PaletteMode
import mui.material.styles.PaletteOptions
import web.cssom.Color

external interface CustomPaletteOptions : PaletteOptions {
    var orange: dynamic
}

val lightPalette = jso<CustomPaletteOptions> {
    mode = PaletteMode.light
    background = jso {
        paper = "#ffffff"
    }
    common = jso {
        black = Color("#111936")
    }
    primary = jso {
        light = "#eef2f6"
        main = "#2196f3"
        dark = "#1e88e5"
        this["200"] = "#90caf9"
        this["800"] = "1565c0"
    }
    secondary = jso {
        light = "#ede7f6"
        main = "#673ab7"
        dark = "#5e35b1"
        this["50"] = "#ede7f6"
        this["200"] = "#b39ddb"
        this["800"] = "#4527a0"
    }
    success = jso {
        light = "#b9f6ca"
        main = "#00e676"
        dark = "#00c853"
        this["200"] = "#69f0ae"
    }
    error = jso {
        light = "#ef9a9a"
        main = "#f44336"
        dark = "#c62828"
    }
    orange = jso {
        light = "#fbe9e7"
        main = "#ffab91"
        dark = "#d84315"
    }
    warning = jso {
        light = "#fff8e1"
        main = "#ffe57f"
        dark = "#ffc107"
    }
    text = jso {
        primary = Color("#bdc8f0")
        secondary = Color("#8492c4")

    }
    grey = jso {
        this["50"] = "#f8fafc"
        this["100"] = "#eef2f6"
        this["200"] = "#e3e8ef"
        this["300"] = "#cdd5df"
        this["500"] = "#697586"
        this["600"] = "#4b5565"
        this["700"] = "#364152"
        this["900"] = "#121926"
    }
}